import * as React from "react";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import { useStore } from "stores/connect";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { getConfig } from "components/configurations/helpers";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import Spinner from "components/common/Spinner";
import { InputDescription, ModalSubmit, IfPermitted } from "components/common";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const StyledDefList = styled.dl.attrs({ className: "deflist" })(
  ({ theme }) => css`
    &&.deflist {
      dd {
        padding-left: ${theme.spacings.md};
        margin-left: 200px;
      }
    }
  `
);
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const PermissionsConfig = () => {
  const [showModal, setShowModal] = useState(false);
  const [config, setConfig] = useState(void 0);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  const sendTelemetry = useSendTelemetry("permissions");
  useEffect(() => {
    ConfigurationsActions.listPermissionsConfig(ConfigurationType.PERMISSIONS_CONFIG).then(() => {
      setConfig(getConfig(ConfigurationType.PERMISSIONS_CONFIG, configuration));
    });
  }, [configuration]);
  const saveConfig = (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.PERMISSIONS_UPDATED, {
      app_action_value: "configuration-save"
    });
    ConfigurationsActions.update(ConfigurationType.PERMISSIONS_CONFIG, values).then(() => {
      setShowModal(false);
    });
  };
  const resetConfig = () => {
    setShowModal(false);
  };
  const modalTitle = "Configure Permissions";
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, "Permissions Configuration"), /* @__PURE__ */ React.createElement("p", null, "These settings can be used to control which entity sharing options are available."), !config ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, "Share with everyone:"), /* @__PURE__ */ React.createElement("dd", null, config.allow_sharing_with_everyone ? "Enabled" : "Disabled"), /* @__PURE__ */ React.createElement("dt", null, "Share with users:"), /* @__PURE__ */ React.createElement("dd", null, config.allow_sharing_with_users ? "Enabled" : "Disabled")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    "Edit configuration"
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: saveConfig, initialValues: config }, ({ isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "allow_sharing_with_everyone",
      id: "shareWithEveryone",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, "Share with everyone")
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: "Control whether it is possible to share with everyone." })), /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "allow_sharing_with_users",
      id: "shareWithUsers",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, "Share with users")
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: "Control whether it is possible to share with single users." }))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: resetConfig,
      isSubmitting,
      isAsyncSubmit: true,
      submitLoadingText: "Update configuration",
      submitButtonText: "Update configuration"
    }
  )))))));
};
export default PermissionsConfig;
